import { IntegrationsMarketplaceGridInstalledNirvanaDataProvider } from '../dataProvider/IntegrationsMarketplaceGridInstalledNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class IntegrationsMarketplaceGridInstalledDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrationsMarketplaceGridInstalledNirvanaDataProvider);
  }
}
